var ua = navigator.userAgent || '';
// 是否极速版
export var isKsnebula = !!ua.toLowerCase().match('ksnebula');
// 是否大屏版
// 大屏版(概念版)已经不维护
// const isKsthanos = !!ua.toLowerCase().match('ksthanos');
// 是否商家侧app
export var isMerchantShop = !!ua.toLowerCase().match('merchantshop');
// 是否在快手app内
export var isKwai = !!ua.toLowerCase().match('kwai');
export var isInYoda = /Yoda/.test(ua);
export var isKsAPP = isKwai || isKsnebula || isInYoda;
